<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12>
          <h3 class="text-center">Edit Currency</h3>
        </v-flex>
        <v-flex xs12 md4 sm6>
          <v-card>
            <v-card-title class="py-1">
              <v-spacer></v-spacer>
              <v-btn small @click.stop.prevent="goTo('/currencies')" color="warning">
                <v-icon left>mdi-cancel</v-icon>Cancel
              </v-btn>
            </v-card-title>
            <v-card-text>
              <edit-currency-form :edit="currency" :errors="errors" :canConvert="canConvert"></edit-currency-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const EditCurrencyForm =  async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "currencies" */ '@/Components/Currencies/edit')

  export default {
    name: 'EditCurrency',
    layout,
    props: [
      'currency',
      'errors',
      'canConvert'
    ],
    components: {
      EditCurrencyForm
    },
    metaInfo () {
      return {
        title: 'Edit Currency',
        titleTemplate: '%s | ' + this.$title,
      }
    },
  }
</script>
